import api from '../api.js';
import { notify } from '../../versa/msgbox.js';
import * as types from '../types.js';

/** Atualiza o cm³ mostrado no formulário. O valor gravado é recalculado na API. */
function refreshVolume(root) {
	const length = Number(String(root.querySelector('#length_cm')?.value || '').replace(',', '.'));
	const width = Number(String(root.querySelector('#width_cm')?.value || '').replace(',', '.'));
	const depth = Number(String(root.querySelector('#depth_cm')?.value || '').replace(',', '.'));
	const target = root.querySelector('#volume_cm3');
	if (!target)
		return;
	if (!(length > 0) || !(width > 0) || !(depth > 0)) {
		target.value = '';
		return;
	}
	target.value = String(Math.round(length * width * depth * 1000) / 1000);
}

export default {

	html: `
		<style>
			#carrier-box #company_id		{ width: 10rem; }
			#carrier-box #id				{ width: 5rem; text-align: right; }
			#carrier-box #carrier_id		{ width: 16rem; }
			#carrier-box #code				{ width: 10rem; }
			#carrier-box #length_cm		{ width: 6rem; text-align: right; }
			#carrier-box #width_cm			{ width: 6rem; text-align: right; }
			#carrier-box #depth_cm			{ width: 6rem; text-align: right; }
			#carrier-box #volume_cm3		{ width: 8rem; text-align: right; }
			#carrier-box #max_weight_kg	{ width: 8rem; text-align: right; }
		</style>
		<form id="carrier-box" class="form" autocomplete="off">
			<datalist id="companies"></datalist>
			<datalist id="carriers"></datalist>
			<div class="fsb">
				<label title="Empresa desta caixa">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador da caixa">Caixa
					<input id="id" type="text" disabled>
				</label>
				<label title="Transportador que usa esta caixa">Transportador<sup>*</sup>
					<input id="carrier_id" type="text" list="carriers" required>
				</label>
				<label title="Código da caixa neste transportador. Pode repetir em outro transportador">Código<sup>*</sup>
					<input id="code" type="text" maxlength="40" required>
				</label>
			</div>
			<div class="fsb mtm">
				<label title="Comprimento em centímetros">Comprimento (cm)<sup>*</sup>
					<input id="length_cm" type="text" inputmode="decimal" required>
				</label>
				<label title="Largura em centímetros">Largura (cm)<sup>*</sup>
					<input id="width_cm" type="text" inputmode="decimal" required>
				</label>
				<label title="Profundidade em centímetros">Profundidade (cm)<sup>*</sup>
					<input id="depth_cm" type="text" inputmode="decimal" required>
				</label>
				<label title="Comprimento × largura × profundidade. O SIAL calcula">cm³
					<input id="volume_cm3" type="text" disabled>
				</label>
				<label title="Peso máximo da caixa, em quilos">Peso máximo (kg)<sup>*</sup>
					<input id="max_weight_kg" type="text" inputmode="decimal" required>
				</label>
				<label title="Inativa não aparece na conferência">Inativo
					<input id="is_disabled" type="checkbox">
				</label>
			</div>
			<div class="fsb mtm">
				<span>
					<button type="button" class="button bn_carrier_box_disable" title="Inativar caixa">Inativar</button>
					<button type="button" class="button bn_carrier_box_enable" title="Ativar caixa">Ativar</button>
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,

	form:
	{
		selector: '#carrier-box',
		init(formset)
		{
			formset.loadList('#companies', 'companies', { labels: ['nick'] });
			Object.getPrototypeOf(this).init.call(this);
			const root = () => formset.dialog?.getNode?.();
			const getCompanyId = () => formset.form.getFieldBySelector('#company_id')?.getValue?.() ?? root()?.querySelector?.('#company_id')?.value;
			const getId = () => root()?.querySelector?.('#id')?.value;
			const setDisabled = (value) => {
				const field = formset.form.getFieldBySelector('#is_disabled');
				if (field) {
					field.setValue(value ? 1 : 0);
					field.refresh();
				}
			};
			const doAction = async (payload) => {
				const companyId = getCompanyId();
				const id = getId();
				if (!companyId || !id)
					return;
				const resp = await api.call(api.patch_carrier_box, companyId, id, payload);
				if (resp != null)
					setDisabled(payload.is_disabled);
				else
					notify('Falha ao atualizar a caixa.', 'Caixas');
			};
			const node = root();
			node?.addEventListener?.('input', (ev) => {
				if (ev.target?.id === 'length_cm' || ev.target?.id === 'width_cm' || ev.target?.id === 'depth_cm')
					refreshVolume(node);
			});
			node?.addEventListener?.('click', (ev) => {
				if (ev.target?.closest?.('.bn_carrier_box_disable')) {
					ev.preventDefault();
					ev.stopPropagation();
					doAction({ is_disabled: true });
					return;
				}
				if (ev.target?.closest?.('.bn_carrier_box_enable')) {
					ev.preventDefault();
					ev.stopPropagation();
					doAction({ is_disabled: false });
				}
			});
			if (node)
				refreshVolume(node);
		},
	},

	fields: [
		{ properties: { selector: '#company_id' }, types: [types.pubsub(), types.datalist()] },
		{ properties: { selector: '#id' }, types: [types.number(0, 2)] },
		{ properties: { selector: '#carrier_id' }, types: [types.pubsub(), types.datalist(), types.observer('company_id'), types.obs_load_options('carriers', { labels: ['nick'] })] },
		{ properties: { selector: '#code' }, types: [] },
		{ properties: { selector: '#length_cm' }, types: [types.number(3)] },
		{ properties: { selector: '#width_cm' }, types: [types.number(3)] },
		{ properties: { selector: '#depth_cm' }, types: [types.number(3)] },
		{ properties: { selector: '#volume_cm3' }, types: [] },
		{ properties: { selector: '#max_weight_kg' }, types: [types.number(3)] },
		{ properties: { selector: '#is_disabled' }, types: [types.checkbox()] },
	]

};
